import React from 'react';
import ExpandableListItem from '../../../../components/molecules/expandable_element';
import SearchIcon from '@material-ui/icons/Search';
import clsx from 'clsx';
import useStyles from './styles';
import FilterForm from './filter_form';
import TranslatedText from 'components/atoms/translated_text';
import { Translations } from '../../configuration';

interface IProps {
  country_code: string | null;
  vat_rate_type_id: string | null;
  valid_from: string | null;
  valid_to: string | null;
}

const Filter = (props: IProps) => {
  const classes = useStyles();

  const Header = () => {
    return (
      <div className={classes.filter_header}>
        <SearchIcon style={{ marginRight: '1rem' }} />
        <span style={{ fontSize: '1.2rem' }}>
          <TranslatedText textMap={Translations.search} />
        </span>
      </div>
    );
  };

  const Body = () => {
    return (
      <FilterForm
        country_code={props.country_code}
        vat_rate_type_id={props.vat_rate_type_id}
        valid_from={props.valid_from}
        valid_to={props.valid_to}
      />
    );
  };

  return (
    <div
      className={clsx({
        [classes.cardLayout]: true,
        [classes.filter]: true,
      })}
    >
      <ExpandableListItem
        renderDataHeader={() => <Header />}
        renderDataBody={() => <Body />}
      />
    </div>
  );
};

export default Filter;
